import { Box, BoxProps, useTheme } from "@mui/material";
import { useScreenSize } from "../../hooks";

export const HCard: React.FC<BoxProps & { variant?: "form" }> = ({
    children,
    style,
    sx,
    variant,
    ...rest
}) => {
    const theme = useTheme();
    const { isXS } = useScreenSize();

    return (
        <Box
            sx={{
                padding: "16px",
                border: theme.styles.altBorder3,
                borderRadius: "8px",
                backgroundColor: theme.palette.extendedGrey2.main,
                ...(variant === "form" && { padding: isXS ? "1rem" : "1.5rem" }),
                ...style,
                ...sx,
            }}
            {...rest}
        >
            {children}
        </Box>
    );
};
